import { StepperBarParams } from './types'
import {
  Breadcumb,
  Wrapper,
  Title,
  Step,
  StepNumber,
  StepTitle,
  StepLine,
  Progress,
  ProgressBar,
  ProgressBarFill,
} from './styled'

const StepperBar = ({ stepNumber }: StepperBarParams) => {
  const progress = () => {
    if (stepNumber === 1) {
      return '0'
    } else if (stepNumber === 2) {
      return '33%'
    } else {
      return '66%'
    }
  }

  return (
    <Wrapper>
      <Breadcumb>
        Products /{' '}
        <span style={{ fontWeight: '700', color: '#ffffff' }}>New</span>
      </Breadcumb>
      <Title>New Product</Title>
      <Step active>
        <StepNumber>1</StepNumber>
        <StepTitle>
          Product Basics <span>Product Information</span>
        </StepTitle>
        <StepLine active={stepNumber === 2 || stepNumber === 3} />
      </Step>
      <Step active={stepNumber === 2 || stepNumber === 3}>
        <StepNumber>2</StepNumber>
        <StepTitle>
          Data Information <span>Coverage, Volume &amp; Attributes</span>
        </StepTitle>
        <StepLine active={stepNumber === 3} />
      </Step>
      <Step active={stepNumber === 3}>
        <StepNumber>3</StepNumber>
        <StepTitle>
          Delivery &amp; Pricing <span>Aliquet tellus ac.</span>
        </StepTitle>
      </Step>
      <Progress>
        {stepNumber === 1 ? '0%' : stepNumber === 2 ? '33%' : '66%'} progress
        <ProgressBar>
          <ProgressBarFill width={progress} />
        </ProgressBar>
      </Progress>
    </Wrapper>
  )
}

export default StepperBar
